// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"961396e1","453":"ada92e73","716":"83f3d28b","770":"514e8ccb","974":"6b96d092"}[chunkId] + ".chunk.js";
};